
export function roundDownToNearest5(coord) {
  return {
    x: coord.x % 5 === 0 && coord.x !== -180 ? coord.x - 5 : Math.floor(coord.x / 5) * 5,
    y: coord.y % 5 === 0 && coord.y !== -90 ? coord.y - 5 : Math.floor(coord.y / 5) * 5
  };
}

export function getPlateIndex({ x, y }) {
  const xIndex = (x + 180) / 5;
  const yIndex = (y + 90) / 5;
  const width = 72;
  return yIndex * width + xIndex;
}